import { AxiosErrorResponse } from "../interface/api_request";
import { CreateAppraisalProps } from "../interface/appraisal";
import { getRequestConfiguration } from "../utils/headerHelper";
import Axios from "../utils/http-request";

export const apiCreateAppraisal = async (fieldValues: CreateAppraisalProps) => {
  const formData = new URLSearchParams();
  // Append all form fields to FormData
  Object.entries(fieldValues).forEach(([key, value]) => {
    if (value !== undefined) {
      formData.append(key, value.toString());
    }
  });
  try {
    const uri = `/appraisals/appraisal`;
    const cfg = await getRequestConfiguration({
      "Content-Type": "application/x-www-form-urlencoded",
    });
    return await Axios.post(uri, formData, cfg);
  } catch (e: any) {
    console.error(e);
    return {
      data: {},
      status: "error",
      msg: e?.response?.data?.message || e?.message,
    };
  }
};

export const apiGetAllEmployeeAppraisal = async (values: {
  employeeId: string;
}) => {
  try {
    const cfg = await getRequestConfiguration({
      "Content-Type": "application/x-www-form-urlencoded",
    });
    const uri = `/appraisals/employee/${values.employeeId}`;
    return await Axios.get(uri, cfg);
  } catch (e: any) {
    const error = e as AxiosErrorResponse;
    const errorMessage =
      error?.response?.data?.message ||
      error?.response?.data?.msg ||
      error?.message ||
      "An error occurred";
    return {
      data: {},
      status: "error",
      msg: errorMessage,
    };
  }
};

export const apiGetAllAppraisal = async () => {
  try {
    const cfg = await getRequestConfiguration({
      "Content-Type": "application/x-www-form-urlencoded",
    });
    const uri = `/appraisals/appraisals`;
    return await Axios.get(uri, cfg);
  } catch (e: any) {
    const error = e as AxiosErrorResponse;
    const errorMessage =
      error?.response?.data?.message ||
      error?.response?.data?.msg ||
      error?.message ||
      "An error occurred";
    return {
      data: {},
      status: "error",
      msg: errorMessage,
    };
  }
};
